export class ReactivePowerAnalysisInput {
  public startDate: string;
  public endDate: string;
  public topologyId: string;
  public forecasting: boolean;
}
